// Generate a URL-friendly ID from heading text
export const generateHeadingId = text => {
  if (!text) return ''

  return text
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '') // Remove special characters
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/-+/g, '-') // Replace multiple hyphens with single
    .trim()
    .replace(/^-|-$/g, '') // Remove leading/trailing hyphens
}

// Extract text content from Prismic rich text
export const extractTextFromRichText = richText => {
  if (!richText || !Array.isArray(richText)) return ''

  return richText
    .map(block => block.text || '')
    .join(' ')
    .trim()
}
